/* Existing Klaviyo form stays in charge of its UI, confirmation and optional SMS.
 * Save referred membership before Klaviyo creates a profile, so existing-member
 * exclusion cannot mistake this same signup for a pre-existing member. */
(function () {
  'use strict';
  var key = 'll_home_referral_v1';
  var valid = /^LL-[23456789ABCDEFGHJKLMNPQRSTUVWXYZ]{6}$/;
  var incoming = (new URLSearchParams(location.search).get('ll_ref') || '').toUpperCase();
  var referral = null;
  try {
    var saved = JSON.parse(localStorage.getItem(key) || 'null');
    if (saved && valid.test(saved.code) && Number.isFinite(saved.at) && saved.at <= Date.now() && Date.now() - saved.at < 30 * 86400000) referral = saved;
  } catch { /* Attribution still works from the current invite URL. */ }
  if (!referral && valid.test(incoming)) {
    referral = {code: incoming, at: Date.now()};
    try { localStorage.setItem(key, JSON.stringify(referral)); } catch { /* Storage may be disabled. */ }
  }
  if (!referral) return;
  var busy = false;
  var savedEmail = null;
  var replaying = false;
  var error;
  function showError(form) {
    if (!error) {
      error = document.createElement('p');
      error.setAttribute('role', 'alert');
      error.setAttribute('style', 'color:inherit;text-align:center;font-size:14px;padding:8px 20px');
      form.appendChild(error);
    }
    error.textContent = 'Your referral signup could not be saved. Please try again.';
  }
  async function intercept(event) {
    if (replaying) return;
    var target = event.target;
    var form = target && target.closest && target.closest('.klaviyo-form-W7KNUy form');
    var button = target && target.closest && target.closest('button');
    if (!form || (event.type === 'click' && !button)) return;
    var input = form.querySelector('input[type="email"]');
    var email = input && input.value.trim().toLowerCase();
    // Let the existing form handle validation and later SMS steps normally.
    if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email) || !input.checkValidity() || savedEmail === email) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy) return;
    busy = true;
    form.setAttribute('aria-busy', 'true');
    if (button) button.setAttribute('aria-disabled', 'true');
    if (error) error.textContent = '';
    try {
      var name = form.querySelector('input[type="text"]');
      var response = await fetch('https://lastlook-dev.last-look.workers.dev/api/referrals/homepage', {
        method: 'POST', credentials: 'omit', headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({email: email, firstName: name ? name.value : '', referralCode: referral.code, consent: true}),
        signal: AbortSignal.timeout(45000)
      });
      var result = await response.json();
      if (!response.ok || result.ok !== true) throw new Error('signup_failed');
      savedEmail = email;
      try { localStorage.removeItem(key); } catch { /* Current page is already saved. */ }
      busy = false;
      form.removeAttribute('aria-busy');
      if (button) button.removeAttribute('aria-disabled');
      replaying = true;
      try { if (button) button.click(); else form.requestSubmit(); }
      finally { replaying = false; }
    } catch { showError(form); }
    finally {
      busy = false;
      form.removeAttribute('aria-busy');
      if (button) button.removeAttribute('aria-disabled');
    }
  }
  // Capture before React/Klaviyo's own click or Enter-key submit handler.
  window.addEventListener('click', intercept, true);
  window.addEventListener('submit', intercept, true);
  function openSignup() {
    var link = document.querySelector('a[href="#kl-signup"]');
    if (link) link.click();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openSignup, {once: true});
  else openSignup();
})();
